import { render, staticRenderFns } from "./limitMsgShow.vue?vue&type=template&id=31558156&"
import script from "./limitMsgShow.vue?vue&type=script&lang=js&"
export * from "./limitMsgShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports